<template>
  <div>
    <Header />
    <hero-section />
    <infos-profit-section />
    <partner-info />
    <infos-specificity-section />
    <infos-process-section />
    <calculator-section :content="calculator" />
    <simulation-section :content="simulation" />
    <scenario-section :content="scenarios">
      <button-open-dialog />
    </scenario-section>
    <questions-section />
    <agreements-dialog v-if="isVisible" />
    <Footer />
    <button-scroll-up />
  </div>
</template>

<script>
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import InfosProfitSection from './components/InfosProfitSection'
import PartnerInfo from './components/PartnerInfo'
import InfosSpecificitySection from './components/InfosSpecificitySection'
import InfosProcessSection from './components/InfosProcessSection'
import QuestionsSection from './components/QuestionsSection'

import AgreementsDialog from '../../partner-components/agreements/AgreementsDialog'
import ButtonScrollUp from '../../partner-components/common/ButtonScrollUp'
import CalculatorSection from '../../partner-components/calculator/CalculatorSection'
import SimulationSection from '../../partner-components/simulation/SimulationSection'
import ScenarioSection from '../../partner-components/scenarios/ScenarioSection'
import ButtonOpenDialog from '../../partner-components/common/ButtonOpenDialog'
import Footer from '../../partner-components/Footer'

import ContentMixin from '../../mixins/content.mixin'

export default {
  name: 'ShoperLayout',
  components: {
    Header,
    HeroSection,
    InfosProfitSection,
    PartnerInfo,
    InfosSpecificitySection,
    QuestionsSection,
    InfosProcessSection,
    CalculatorSection,
    SimulationSection,
    ScenarioSection,
    ButtonOpenDialog,
    AgreementsDialog,
    ButtonScrollUp,
    Footer
  },
  mixins: [ContentMixin]
}

</script>
<style src="../../assets/partner-scss/style.scss" lang="scss"></style>
<style lang="scss" src="../../assets/partner-scss/partners/shoper/_global.scss"></style>
